import React, { FormEvent, useContext, useRef, useState } from 'react'
import { Form, Nav } from 'react-bootstrap'
import Button from 'app/modules/shared/components/button'
import { createReportsSearchLink, getInvalidReportSearchQueryMessage } from 'app/modules/reports/helpers'
import { useNavigate } from 'react-router'
import TextInput from '../text-input'
import { MainNotificationContext } from 'app/modules/shared'

const Search = ({ className }: { className?: string }) => {
  const [isSearchBarOpen, setSearchBarOpen] = useState<boolean>()
  const [query, setQuery] = useState('')

  const buttonRef = useRef(null)
  const navigate = useNavigate()
  const mainNotification = useContext(MainNotificationContext)

  const toggleSearchBar = () => {
    setQuery('')
    setSearchBarOpen(!isSearchBarOpen)
  }

  const submitSearch = (e: FormEvent) => {
    e.preventDefault()
    const validationError = getInvalidReportSearchQueryMessage(query)

    if (validationError) {
      mainNotification.setMessageData(validationError, 'danger')
      return
    }

    setQuery('')
    setSearchBarOpen(false)
    const searchLink = createReportsSearchLink({ query })
    navigate(searchLink)
  }

  return (
    <div className={`search-wrapper ${className}`} ref={buttonRef}>
      {isSearchBarOpen ? (
        <div className="search-bar">
          <Form className="search-form" onSubmit={submitSearch}>
            <TextInput
              placeholder="File name, URL, IP, Domain or Hash"
              className="search-bar-input"
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              clearable
              postfix={
                <Button
                  id="appbar-search-submit"
                  type="submit"
                  variant="tertiary"
                  aria-label="Submit search"
                  disabled={!query.length}
                >
                  <i className="ds3-icon ds3-search ds3-hover" />
                </Button>
              }
            />
          </Form>
          <div className="search-toggle">
            <Nav.Link className="p-0" onClick={toggleSearchBar} aria-label="Toggle search">
              <i className="ds3-icon ds3-chevron-right color-text-main" />
            </Nav.Link>
          </div>
        </div>
      ) : (
        <div className="appbar-item search-toggle cursor-default">
          <Nav.Link
            className="py-0 ds3-hover"
            aria-label="Toggle search"
            style={{ color: 'inherit' }}
            onClick={toggleSearchBar}
          >
            <i className="ds3-icon ds3-search" />
          </Nav.Link>
        </div>
      )}
    </div>
  )
}

export default Search
